export default __webpack_public_path__ + "static/media/pages_created.91ba395f.PNG";